<template>
    <div>
        <!-- <age-verification ref="av"></age-verification> -->
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import JS from './MainApp.js'

export default{
    mixins:[JS]

}
</script>


<style>
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
    a{
        cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// MainApp.vue?4432b27c